/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanBaselineDto
 */
export interface ExecutionPlanBaselineDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanBaselineDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanBaselineDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanBaselineDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanBaselineDto
     */
    label?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecutionPlanBaselineDto
     */
    baselineData?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanBaselineDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanBaselineDto
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the ExecutionPlanBaselineDto interface.
 */
export function instanceOfExecutionPlanBaselineDto(value: object): value is ExecutionPlanBaselineDto {
    return true;
}

export function ExecutionPlanBaselineDtoFromJSON(json: any): ExecutionPlanBaselineDto {
    return ExecutionPlanBaselineDtoFromJSONTyped(json, false);
}

export function ExecutionPlanBaselineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanBaselineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'label': json['label'] == null ? undefined : json['label'],
        'baselineData': json['baselineData'] == null ? undefined : json['baselineData'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function ExecutionPlanBaselineDtoToJSON(json: any): ExecutionPlanBaselineDto {
    return ExecutionPlanBaselineDtoToJSONTyped(json, false);
}

export function ExecutionPlanBaselineDtoToJSONTyped(value?: ExecutionPlanBaselineDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'planId': value['planId'],
        'label': value['label'],
        'baselineData': value['baselineData'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
    };
}

